// extracted by mini-css-extract-plugin
export default {"body":"image_body__R6H7d","cropper":"image_cropper__oQjWY","controls":"image_controls__SxWxu"};